const CHANGE_LOG_READ_KEY = 'changeLogRead';
const DEFAULT_CHANGE_LOG_READ_DATE = '2022-12-12';

export const getChangeLogReadDate = (): Date => {
    const changeLogReadString = localStorage.getItem(CHANGE_LOG_READ_KEY);

    if (changeLogReadString) {
        const parsedDate = new Date(changeLogReadString);

        if (!isNaN(parsedDate.getTime())) {
            return parsedDate;
        }
    }

    return new Date(DEFAULT_CHANGE_LOG_READ_DATE);
};

export const isChangeLogUnread = (createdAt?: string | Date | null): boolean =>
    Boolean(createdAt) && new Date(createdAt || '').getTime() >= getChangeLogReadDate().getTime();

export const setChangeLogRead = (): void => {
    localStorage.setItem(CHANGE_LOG_READ_KEY, new Date().toString());
};
